import PropTypes from 'prop-types';
import DefaultBetContentImpl from './default-bet-content.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * Default bet content view.
 *
 * @class DefaultBetContent
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * Default bet content view prop types.
 *
 * @property {Mojito.Services.Betslip.types.Bet} bet - Bet.
 * @property {boolean} [suspended = false] - Flag indicating whether the bet is suspended.
 * @property {boolean} [expired = false] - Flag indicating whether the bet is expired.
 * @property {boolean} [showBanker = false] - Flag to show banker toggle button.
 * @property {boolean} [isBankerPending = false] - Flag to show if setting of banker bet is in progress.
 * @property {Mojito.Services.Betslip.types.BETSLIP_STATUS} [betslipStatus] - Betslip status.
 * @property {boolean} [isBetEachWay = false] - Flag to indicate if betWay is EACH_WAY.
 * @property {Mojito.Services.Betslip.types.BetStake} [betStake = {}] - Stake information.
 * @property {boolean} [hasHcapChange = false] - Flag to indicate if bet has handicap changes.
 * @property {boolean} [hasOddsChange = false] - Flag to indicate if bet has odds changes.
 * @property {Function} [cbRemoveBet = ()=>{}] - Callback for when a bet is removed from the slip.
 * @property {Function} [onStakeInputFocus = () => {}] - Callback on stake input focus.
 * @property {Function} [onSelectionInfoClick = () => {}] - Callback triggered after click on selection name, market name or event name.
 * @property {boolean} [showStake] - Flag indicating whether the stake input should be shown.
 * @property {boolean} [showEachWay = false] - Flag to show each way toggle button.
 * @property {boolean} [isTeaser = false] - Boolean value indicating the current stake group is the teaser group.
 *
 * @memberof Mojito.Modules.BetslipView.SingleBet
 */
const propTypes = {
    suspended: PropTypes.bool,
    expired: PropTypes.bool,
    showBanker: PropTypes.bool,
    bet: PropTypes.object.isRequired,
    isBankerPending: PropTypes.bool,
    betslipStatus: PropTypes.string,
    isBetEachWay: PropTypes.bool,
    betStake: PropTypes.object,
    hasHcapChange: PropTypes.bool,
    hasOddsChange: PropTypes.bool,
    showEachWay: PropTypes.bool,
    showStake: PropTypes.bool,
    onStakeInputFocus: PropTypes.func,
    onSelectionInfoClick: PropTypes.func,
    cbRemoveBet: PropTypes.func,
    isTeaser: PropTypes.bool,
};

const defaultProps = {
    suspended: false,
    expired: false,
    showBanker: false,
    isBankerPending: false,
    isBetEachWay: false,
    betStake: {},
    hasHcapChange: false,
    hasOddsChange: false,
    showStake: false,
    showEachWay: false,
    onStakeInputFocus: noop,
    onSelectionInfoClick: noop,
    cbRemoveBet: noop,
    isTeaser: false,
};

export default UIView('DefaultBetContent', DefaultBetContentImpl, propTypes, defaultProps);
